module.exports = __webpack_public_path__ + "videos/optimised/6fbe8a4e729c2e793ac2ddc335d3eb61.mp4";